import { InputConstraints } from '@infotech-soe/erp-ui-kit';
import { createContext, useContext } from 'react';

type FormOnSubmit = () => void;

export type FormContextState = {
  isFormValid: boolean;
  errors: Map<string, InputConstraints>;
  errorMessages: Map<string, string>;
  onValidate: (
    errors: InputConstraints,
    name?: string,
    isDirty?: boolean,
    limits?: {
      min?: number;
      max?: number;
      minLength?: number;
      maxLength?: number;
      currentLength?: number;
    }
  ) => void;
  onSubmit: FormOnSubmit;
};

export const FormContext = createContext<FormContextState | null>(null);

export function useFormContext(): FormContextState {
  const ctx = useContext(FormContext);
  if (!ctx) throw new Error('No FormContext');
  return ctx as FormContextState;
}
